import { useEffect } from 'react';
import reenviar_icon from "../../../../assets/vw/svg/reenviar-azul.svg";

function formatISOToDateTime(isoString) {
    const date = new Date(isoString);

    const pad = (n) => n.toString().padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

const CardContenido = ({ infoCard, handleReenviar, setShowContent }) => {

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mb-4 d-flex flex-wrap"} style={{ marginTop: '20px' }} >
                <div className={"mr-5"}>
                    <div className="select-card-content-title font-azul-morado-secundario font-weight-bolder">Fecha creación:</div>
                    <div className="select-card-content-description">{infoCard.original.fechaCreacion ? formatISOToDateTime(infoCard.original.fechaCreacion) : '-'}</div>
                </div>
                <div className={"mr-5"}>
                    <div className="select-card-content-title font-azul-morado-secundario font-weight-bolder">Estado Correo:</div>
                    <div className={"select-card-content-description"}>{infoCard.original.estadoCorreo ? (infoCard.original.estadoCorreo) : '-'}</div>
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={"ps-2 pt-2"}>
                </div>
                <div className={"d-flex align-items-end"}>
                    <button
                        className="button_icon-vw"
                        type="button"
                        onClick={() => handleReenviar({ row: infoCard.original })}
                    >
                        <div className="d-flex font-azul-claro-secundario">
                            {" "}
                            <img
                                src={reenviar_icon}
                                alt="reenviar"
                                className="px-2"
                            ></img>{" "}
                            Reenviar
                        </div>
                    </button>
                </div>
            </div>
        </>
    );
}

export default CardContenido;